import React from 'react';
import FeesModal, { FeesModalProps } from '../feesModal/FeesModal';
import { FeesAction } from 'lib/type/enums';

interface PaymentFeeModalProps extends Readonly<FeesModalProps> {}

function PaymentFeeModal({
    fee,
    handleSubmit,
    closeModal,
    isInternalPayee,
    amount,
}: PaymentFeeModalProps) {
    return (
        <FeesModal
            action={FeesAction.PAYMENT}
            fee={fee}
            handleSubmit={handleSubmit}
            closeModal={closeModal}
            isInternalPayee={isInternalPayee}
            amount={amount}
        />
    );
}

export default PaymentFeeModal;
